import React, { useEffect, useState } from "react";
import style from "../Application.module.scss";
import pageHeadingStyles from "../../../styles/PageHeader.module.scss";
import ButtonIcon from "../../../components/ButtonIcon/ButtonIcon";
import SearchInput from "../../../components/SearchInput/SearchInput";
import ApplicationListing from "./ApplicationListing";
import FilterDrawer from "./FIlter/FilterDrawer/FilterDrawer";
import { getPreapp } from "../../../../api";
import useCommonStore from "../../../stores/common";
import useApplicationStore from "../../../stores/application";

function Application() {
  const setFilterDrawerOpen = useCommonStore(
    (state) => state.setFilterDrawerOpen,
  );
  const appFilterSearchQuery = useApplicationStore(
    (state) => state.appFilterSearchQuery,
  );
  const setAppFilterSearchQuery = useApplicationStore(
    (state) => state.setAppFilterSearchQuery,
  );
  const setPageCount = useApplicationStore((state) => state.setPageCount);
  const setPreapps = useApplicationStore((state) => state.setPreapps);
  const setTotalItems = useApplicationStore((state) => state.setTotalItems);
  const setItemsPerPage = useApplicationStore((state) => state.setItemsPerPage);
  const setRelationshipManagers = useApplicationStore(
    (state) => state.setRelationshipManagers,
  );

  const [searchText, setSearchText] = useState("");
  const [filerApplied, setFilterApplied] = useState(false);

  const onChangeSearchInput = (e) => {
    setSearchText(e.target.value);
    setAppFilterSearchQuery({
      search: e.target.value,
      page: 1,
    });
  };

  const loadPreapps = () => {
    getPreapp(appFilterSearchQuery).then((res) => {
      if(res.status){
        setRelationshipManagers(res.relation_manager);
        let response = res.data;
        setPreapps(response.data);
        setPageCount(response.last_page);
        if (response?.total) {
          setTotalItems(response.total);
          setItemsPerPage(response.per_page);
        }
      }
    });
  };

  useEffect(() => {
    loadPreapps();

    setFilterApplied(
      appFilterSearchQuery.created_from !== "" ||
      appFilterSearchQuery.created_to !== "" ||
      appFilterSearchQuery.search !== "" ||
      appFilterSearchQuery.progression_id.length !== 0,
    );
  }, [JSON.stringify(appFilterSearchQuery)]);

  return (
    <>
      <div className={pageHeadingStyles.page_heading}>
        <div className={pageHeadingStyles.title_contents}>
          <p>Applications</p>
        </div>
        <div className={style.right_side}>
          <SearchInput onChange={onChangeSearchInput} value={searchText} />

          <ButtonIcon
            bgColor="#EDEDF4"
            onClick={() => setFilterDrawerOpen(true)}
            className={style.filter_button}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M14.4125 3.09564C14.3355 2.91784 14.208 2.76658 14.0458 2.66068C13.8835 2.55477 13.6937 2.49891 13.5 2.50002H2.49998C2.30644 2.5004 2.11717 2.55694 1.95512 2.66277C1.79308 2.76861 1.66523 2.91919 1.58709 3.09626C1.50894 3.27332 1.48386 3.46926 1.51488 3.6603C1.54591 3.85134 1.6317 4.02928 1.76186 4.17252L1.76686 4.17814L5.99998 8.69814V13.5C5.99994 13.681 6.04902 13.8586 6.14198 14.0139C6.23494 14.1692 6.36831 14.2963 6.52785 14.3818C6.6874 14.4672 6.86714 14.5078 7.04792 14.4991C7.2287 14.4904 7.40373 14.4329 7.55436 14.3325L9.55436 12.9988C9.69146 12.9074 9.80388 12.7837 9.88162 12.6384C9.95936 12.4932 10 12.331 9.99998 12.1663V8.69814L14.2337 4.17814L14.2387 4.17252C14.3703 4.02993 14.4569 3.85176 14.4878 3.66025C14.5187 3.46873 14.4925 3.27236 14.4125 3.09564ZM9.13623 8.16127C9.04974 8.25297 9.00107 8.37396 8.99998 8.50002V12.1663L6.99998 13.5V8.50002C7.00002 8.37305 6.95176 8.25083 6.86498 8.15814L2.49998 3.50002H13.5L9.13623 8.16127Z"
                fill="#3A383F"
              />
            </svg>
            {filerApplied && (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="8"
                height="8"
                viewBox="0 0 8 8"
                fill="none"
              >
                <path
                  d="M3.99992 6.83333C5.74882 6.83333 7.16658 5.41557 7.16658 3.66667C7.16658 1.91777 5.74882 0.5 3.99992 0.5C2.25102 0.5 0.833252 1.91777 0.833252 3.66667C0.833252 5.41557 2.25102 6.83333 3.99992 6.83333Z"
                  fill="#E03B24"
                  stroke="#EDEDF4"
                />
              </svg>
            )}
          </ButtonIcon>
        </div>
      </div>

      <div className={style.card}>
        <ApplicationListing fetchList={loadPreapps} />
      </div>

      <FilterDrawer />

    </>
  );
}

export default Application;
